(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-lp-checklist"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ts-lp-checklist__input').forEach((input) => {
    input.addEventListener('change', function () {
      const checklist = this.closest('.ts-lp-checklist');
      const checkedCount = checklist.querySelectorAll('.ts-lp-checklist__input:checked').length;
      const benefits = checklist.querySelector('.ts-lp-checklist__benefits');

      if (benefits) {
        const isVisible = benefits.style.display === 'flex';
        benefits.style.display = checkedCount >= 2 ? 'flex' : 'none';
        if (checkedCount >= 2 && !isVisible) {
          benefits.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
